import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
};

export enum AccomodationType {
  AccomodationHotel = 'ACCOMODATION_HOTEL',
  AccomodationPension = 'ACCOMODATION_PENSION',
  AccomodationPrivate = 'ACCOMODATION_PRIVATE'
}

export type Artist = {
  __typename?: 'Artist';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  rider_link?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vat_invoicing?: Maybe<Scalars['Boolean']['output']>;
};

export type ArtistInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  rider_link?: InputMaybe<Scalars['String']['input']>;
  vat_invoicing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  access_token?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ConfirmationInput = {
  confirmed_email?: InputMaybe<Scalars['String']['input']>;
  confirmed_name?: InputMaybe<Scalars['String']['input']>;
  confirmed_phone?: InputMaybe<Scalars['String']['input']>;
};

export type DataAccomodationInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  accomodation_breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  accomodation_check_in?: InputMaybe<Scalars['String']['input']>;
  accomodation_check_out?: InputMaybe<Scalars['String']['input']>;
  accomodation_city?: InputMaybe<Scalars['String']['input']>;
  accomodation_event_distance?: InputMaybe<Scalars['Float']['input']>;
  accomodation_gps?: InputMaybe<Scalars['String']['input']>;
  accomodation_internet_access?: InputMaybe<Scalars['Boolean']['input']>;
  accomodation_name?: InputMaybe<Scalars['String']['input']>;
  accomodation_phone?: InputMaybe<Scalars['String']['input']>;
  accomodation_street?: InputMaybe<Scalars['String']['input']>;
  accomodation_type?: InputMaybe<AccomodationType>;
  accomodation_web?: InputMaybe<Scalars['String']['input']>;
  accomodation_zip?: InputMaybe<Scalars['String']['input']>;
};

export type DataEventInput = {
  artist_id?: InputMaybe<Scalars['ID']['input']>;
  event_address_city?: InputMaybe<Scalars['String']['input']>;
  event_address_gps?: InputMaybe<Scalars['String']['input']>;
  event_address_place?: InputMaybe<Scalars['String']['input']>;
  event_address_street?: InputMaybe<Scalars['String']['input']>;
  event_address_zip?: InputMaybe<Scalars['String']['input']>;
  event_date?: InputMaybe<Scalars['Date']['input']>;
  event_name?: InputMaybe<Scalars['String']['input']>;
};

export type DataFeeInput = {
  fee_amount?: InputMaybe<Scalars['Int']['input']>;
  fee_other?: InputMaybe<Scalars['String']['input']>;
  fee_paying_email?: InputMaybe<Scalars['String']['input']>;
  fee_paying_name?: InputMaybe<Scalars['String']['input']>;
  fee_payment_type?: InputMaybe<PaymentType>;
  fee_travel?: InputMaybe<Scalars['Int']['input']>;
  fee_type?: InputMaybe<FeeType>;
};

export type DataPromoterInput = {
  contract_address_city?: InputMaybe<Scalars['String']['input']>;
  contract_address_street?: InputMaybe<Scalars['String']['input']>;
  contract_address_zip?: InputMaybe<Scalars['String']['input']>;
  contract_ico?: InputMaybe<Scalars['String']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  promoter_email?: InputMaybe<Scalars['String']['input']>;
  promoter_name?: InputMaybe<Scalars['String']['input']>;
  promoter_phone?: InputMaybe<Scalars['String']['input']>;
};

export type DataTechInput = {
  tech_contact_email?: InputMaybe<Scalars['String']['input']>;
  tech_contact_name?: InputMaybe<Scalars['String']['input']>;
  tech_contact_phone?: InputMaybe<Scalars['String']['input']>;
  tech_sound_email?: InputMaybe<Scalars['String']['input']>;
  tech_sound_name?: InputMaybe<Scalars['String']['input']>;
  tech_sound_phone?: InputMaybe<Scalars['String']['input']>;
};

export type DataTimesInput = {
  time_arrival?: InputMaybe<Scalars['String']['input']>;
  time_dinner?: InputMaybe<Scalars['String']['input']>;
  time_hall_opening?: InputMaybe<Scalars['String']['input']>;
  time_performance?: InputMaybe<Scalars['String']['input']>;
  time_podium_access?: InputMaybe<Scalars['String']['input']>;
  time_sound_test?: InputMaybe<Scalars['String']['input']>;
};

export enum FeeType {
  FeeFixed = 'FEE_FIXED',
  FeeOther = 'FEE_OTHER'
}

export type FilterRequestInput = {
  artistIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  confirmRequest?: Maybe<Request>;
  deleteOrganizationEmail?: Maybe<OrganizationEmail>;
  login: AuthPayload;
  logout: LogoutResponse;
  refreshToken: AuthPayload;
  updateExported?: Maybe<Request>;
  updateOrganizationPrimaryEmail?: Maybe<Organization>;
  updatePassword: UpdatePasswordResponse;
  updateProfile: UpdateProfileResponse;
  updateRequestDataAccomodation?: Maybe<Request>;
  updateRequestDataEvent?: Maybe<Request>;
  updateRequestDataFee?: Maybe<Request>;
  updateRequestDataPromoter?: Maybe<Request>;
  updateRequestDataStart?: Maybe<Request>;
  updateRequestDataTech?: Maybe<Request>;
  updateRequestDataTimes?: Maybe<Request>;
  upsertArtist?: Maybe<Artist>;
  upsertOrganizationEmail?: Maybe<OrganizationEmail>;
  upsertRequest?: Maybe<Request>;
  upsertRequestPropertyValue?: Maybe<Request>;
  urgentRequest?: Maybe<Request>;
};


export type MutationConfirmRequestArgs = {
  input?: InputMaybe<ConfirmationInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteOrganizationEmailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};


export type MutationRefreshTokenArgs = {
  input?: InputMaybe<RefreshTokenInput>;
};


export type MutationUpdateExportedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateOrganizationPrimaryEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePassword;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateRequestDataAccomodationArgs = {
  input?: InputMaybe<DataAccomodationInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRequestDataEventArgs = {
  input?: InputMaybe<DataEventInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRequestDataFeeArgs = {
  input?: InputMaybe<DataFeeInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRequestDataPromoterArgs = {
  input?: InputMaybe<DataPromoterInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRequestDataStartArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRequestDataTechArgs = {
  input?: InputMaybe<DataTechInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRequestDataTimesArgs = {
  input?: InputMaybe<DataTimesInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertArtistArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<ArtistInput>;
};


export type MutationUpsertOrganizationEmailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<OrganizationEmailInput>;
};


export type MutationUpsertRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<RequestInput>;
};


export type MutationUpsertRequestPropertyValueArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUrgentRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NewPasswordWithCodeInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type Organization = {
  __typename?: 'Organization';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OrganizationEmail = {
  __typename?: 'OrganizationEmail';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  id_organization?: Maybe<Scalars['ID']['output']>;
  type: OrganizationEmailType;
};

export type OrganizationEmailInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganizationEmailType>;
};

export enum OrganizationEmailType {
  EmailBcc = 'EMAIL_BCC',
  EmailCc = 'EMAIL_CC',
  EmailTo = 'EMAIL_TO'
}

export enum PaymentType {
  PaymentCash = 'PAYMENT_CASH',
  PaymentInvoice = 'PAYMENT_INVOICE'
}

export type Query = {
  __typename?: 'Query';
  artist?: Maybe<Artist>;
  artists: Array<Maybe<Artist>>;
  booker?: Maybe<Organization>;
  bookerArtists: Array<Artist>;
  bookerByRequestUrl?: Maybe<Organization>;
  currentUser?: Maybe<User>;
  organization?: Maybe<Organization>;
  organizationEmails: Array<Maybe<OrganizationEmail>>;
  request?: Maybe<Request>;
  requestCounts?: Maybe<RequestCountsResponse>;
  requestDetail?: Maybe<Request>;
  requestState?: Maybe<Array<Maybe<RequestState>>>;
  requests: Array<Maybe<Request>>;
};


export type QueryArtistArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryArtistsArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookerArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookerByRequestUrlArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestCountsArgs = {
  filter?: InputMaybe<FilterRequestInput>;
};


export type QueryRequestDetailArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestStateArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestsArgs = {
  filter?: InputMaybe<FilterRequestInput>;
  type?: InputMaybe<RequestType>;
};

export type RefreshTokenInput = {
  refresh_token?: InputMaybe<Scalars['String']['input']>;
};

export type RefreshTokenPayload = {
  __typename?: 'RefreshTokenPayload';
  access_token: Scalars['String']['output'];
  expires_in: Scalars['Int']['output'];
  refresh_token: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  status: RegisterStatuses;
  tokens?: Maybe<AuthPayload>;
};

export enum RegisterStatuses {
  MustVerifyEmail = 'MUST_VERIFY_EMAIL',
  Success = 'SUCCESS'
}

export type Request = {
  __typename?: 'Request';
  accomodation?: Maybe<Scalars['Boolean']['output']>;
  accomodation_breakfast?: Maybe<Scalars['Boolean']['output']>;
  accomodation_check_in?: Maybe<Scalars['String']['output']>;
  accomodation_check_out?: Maybe<Scalars['String']['output']>;
  accomodation_city?: Maybe<Scalars['String']['output']>;
  accomodation_event_distance?: Maybe<Scalars['Float']['output']>;
  accomodation_gps?: Maybe<Scalars['String']['output']>;
  accomodation_internet_access?: Maybe<Scalars['Boolean']['output']>;
  accomodation_name?: Maybe<Scalars['String']['output']>;
  accomodation_phone?: Maybe<Scalars['String']['output']>;
  accomodation_street?: Maybe<Scalars['String']['output']>;
  accomodation_type?: Maybe<AccomodationType>;
  accomodation_update_at?: Maybe<Scalars['DateTime']['output']>;
  accomodation_web?: Maybe<Scalars['String']['output']>;
  accomodation_zip?: Maybe<Scalars['String']['output']>;
  artist?: Maybe<Artist>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  confirmed_at?: Maybe<Scalars['DateTime']['output']>;
  confirmed_email?: Maybe<Scalars['String']['output']>;
  confirmed_name?: Maybe<Scalars['String']['output']>;
  confirmed_phone?: Maybe<Scalars['String']['output']>;
  contract_address_city?: Maybe<Scalars['String']['output']>;
  contract_address_street?: Maybe<Scalars['String']['output']>;
  contract_address_zip?: Maybe<Scalars['String']['output']>;
  contract_ico?: Maybe<Scalars['String']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  event_address_city?: Maybe<Scalars['String']['output']>;
  event_address_gps?: Maybe<Scalars['String']['output']>;
  event_address_place?: Maybe<Scalars['String']['output']>;
  event_address_street?: Maybe<Scalars['String']['output']>;
  event_address_zip?: Maybe<Scalars['String']['output']>;
  event_date?: Maybe<Scalars['Date']['output']>;
  event_name?: Maybe<Scalars['String']['output']>;
  exported_at?: Maybe<Scalars['DateTime']['output']>;
  fee_amount?: Maybe<Scalars['Int']['output']>;
  fee_other?: Maybe<Scalars['String']['output']>;
  fee_paying_email?: Maybe<Scalars['String']['output']>;
  fee_paying_name?: Maybe<Scalars['String']['output']>;
  fee_payment_type?: Maybe<PaymentType>;
  fee_total?: Maybe<Scalars['Int']['output']>;
  fee_travel?: Maybe<Scalars['Int']['output']>;
  fee_type?: Maybe<FeeType>;
  fee_vat?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  link_contract?: Maybe<Scalars['String']['output']>;
  link_invoice?: Maybe<Scalars['String']['output']>;
  main_email?: Maybe<Scalars['String']['output']>;
  notified_at?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  prefilled?: Maybe<Scalars['Boolean']['output']>;
  promoter_email?: Maybe<Scalars['String']['output']>;
  promoter_name?: Maybe<Scalars['String']['output']>;
  promoter_phone?: Maybe<Scalars['String']['output']>;
  steps_done?: Maybe<Scalars['Int']['output']>;
  tech_contact_email?: Maybe<Scalars['String']['output']>;
  tech_contact_name?: Maybe<Scalars['String']['output']>;
  tech_contact_phone?: Maybe<Scalars['String']['output']>;
  tech_sound_email?: Maybe<Scalars['String']['output']>;
  tech_sound_name?: Maybe<Scalars['String']['output']>;
  tech_sound_phone?: Maybe<Scalars['String']['output']>;
  tech_update_at?: Maybe<Scalars['DateTime']['output']>;
  time_arrival?: Maybe<Scalars['String']['output']>;
  time_dinner?: Maybe<Scalars['String']['output']>;
  time_hall_opening?: Maybe<Scalars['String']['output']>;
  time_performance?: Maybe<Scalars['String']['output']>;
  time_podium_access?: Maybe<Scalars['String']['output']>;
  time_sound_test?: Maybe<Scalars['String']['output']>;
  time_update_at?: Maybe<Scalars['DateTime']['output']>;
};

export type RequestCountsResponse = {
  __typename?: 'RequestCountsResponse';
  completed?: Maybe<Scalars['Int']['output']>;
  confirmed?: Maybe<Scalars['Int']['output']>;
  exported?: Maybe<Scalars['Int']['output']>;
  incompleted?: Maybe<Scalars['Int']['output']>;
  nonConfirmed?: Maybe<Scalars['Int']['output']>;
  nonExported?: Maybe<Scalars['Int']['output']>;
  past?: Maybe<Scalars['Int']['output']>;
};

export type RequestInput = {
  artist_id?: InputMaybe<Scalars['ID']['input']>;
  event_address_city?: InputMaybe<Scalars['String']['input']>;
  event_address_place?: InputMaybe<Scalars['String']['input']>;
  event_date?: InputMaybe<Scalars['Date']['input']>;
  fee_amount?: InputMaybe<Scalars['Int']['input']>;
  fee_other?: InputMaybe<Scalars['String']['input']>;
  fee_travel?: InputMaybe<Scalars['Int']['input']>;
  fee_type?: InputMaybe<FeeType>;
  main_email?: InputMaybe<Scalars['String']['input']>;
};

export type RequestState = {
  __typename?: 'RequestState';
  finished?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export enum RequestType {
  Completed = 'COMPLETED',
  Exported = 'EXPORTED',
  Incompleted = 'INCOMPLETED',
  Notexported = 'NOTEXPORTED',
  Past = 'PAST',
  Submitted = 'SUBMITTED',
  Unsubmitted = 'UNSUBMITTED'
}

export type SocialLoginInput = {
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdatePassword = {
  old_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
};

export type UpdatePasswordResponse = {
  __typename?: 'UpdatePasswordResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type UpdateProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileResponse = {
  __typename?: 'UpdateProfileResponse';
  currentUser: User;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VerifyEmailInput = {
  token: Scalars['String']['input'];
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, name: string, email: string } | null };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', access_token?: string | null, refresh_token?: string | null } };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'AuthPayload', access_token?: string | null, refresh_token?: string | null } };

export type BaseRequestBookerFragmentFragment = { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', name?: string | null, logo?: string | null, url?: string | null, email?: string | null } | null };

export type OrganizationEmailsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationEmailsQuery = { __typename?: 'Query', organizationEmails: Array<{ __typename?: 'OrganizationEmail', id: string, type: OrganizationEmailType, email?: string | null } | null> };

export type RequestCountsQueryVariables = Exact<{
  filter?: InputMaybe<FilterRequestInput>;
}>;


export type RequestCountsQuery = { __typename?: 'Query', requestCounts?: { __typename?: 'RequestCountsResponse', confirmed?: number | null, completed?: number | null, incompleted?: number | null, exported?: number | null, nonExported?: number | null, past?: number | null, nonConfirmed?: number | null } | null };

export type RequestsQueryVariables = Exact<{
  type?: InputMaybe<RequestType>;
  filter?: InputMaybe<FilterRequestInput>;
}>;


export type RequestsQuery = { __typename?: 'Query', requests: Array<{ __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null } | null> };

export type BookerRequestQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookerRequestQuery = { __typename?: 'Query', request?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null } | null };

export type RequestDetailQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestDetailQuery = { __typename?: 'Query', requestDetail?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null } | null };

export type ArtistQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ArtistQuery = { __typename?: 'Query', artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, organization_id?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null };

export type BookerArtistsQueryVariables = Exact<{ [key: string]: never; }>;


export type BookerArtistsQuery = { __typename?: 'Query', bookerArtists: Array<{ __typename?: 'Artist', id: string, name?: string | null, url?: string | null, organization_id?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null }> };

export type UpsertArtistMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ArtistInput;
}>;


export type UpsertArtistMutation = { __typename?: 'Mutation', upsertArtist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, organization_id?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null };

export type UpsertOrganizationEmailMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: OrganizationEmailInput;
}>;


export type UpsertOrganizationEmailMutation = { __typename?: 'Mutation', upsertOrganizationEmail?: { __typename?: 'OrganizationEmail', id: string, type: OrganizationEmailType, email?: string | null } | null };

export type DeleteOrganizationEmailMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteOrganizationEmailMutation = { __typename?: 'Mutation', deleteOrganizationEmail?: { __typename?: 'OrganizationEmail', id: string, type: OrganizationEmailType, email?: string | null } | null };

export type UpdateOrganizationPrimaryEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationPrimaryEmailMutation = { __typename?: 'Mutation', updateOrganizationPrimaryEmail?: { __typename?: 'Organization', name?: string | null, logo?: string | null, url?: string | null, email?: string | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePassword;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'UpdatePasswordResponse', status: string, message?: string | null } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'UpdateProfileResponse', status: boolean, message?: string | null, currentUser: { __typename?: 'User', id: string, name: string, email: string } } };

export type UpsertRequestPropertyValueMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertRequestPropertyValueMutation = { __typename?: 'Mutation', upsertRequestPropertyValue?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null } | null };

export type UpsertRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: RequestInput;
}>;


export type UpsertRequestMutation = { __typename?: 'Mutation', upsertRequest?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null } | null };

export type UpdateExportedMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateExportedMutation = { __typename?: 'Mutation', updateExported?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null } | null };

export type UrgentRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UrgentRequestMutation = { __typename?: 'Mutation', urgentRequest?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_vat?: boolean | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, tech_update_at?: string | null, time_update_at?: string | null, accomodation_update_at?: string | null, exported_at?: string | null, notified_at?: string | null, isCompleted?: boolean | null, link_invoice?: string | null, link_contract?: string | null, prefilled?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null } | null };

export type BaseRequestBookingFragmentFragment = { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null };

export type BookerQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookerQuery = { __typename?: 'Query', booker?: { __typename?: 'Organization', url?: string | null, logo?: string | null } | null };

export type BookerByRequestUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookerByRequestUrlQuery = { __typename?: 'Query', bookerByRequestUrl?: { __typename?: 'Organization', url?: string | null, logo?: string | null } | null };

export type BookingRequestQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookingRequestQuery = { __typename?: 'Query', request?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type RequestStateQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestStateQuery = { __typename?: 'Query', requestState?: Array<{ __typename?: 'RequestState', id: string, finished?: boolean | null } | null> | null };

export type RequestQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestQuery = { __typename?: 'Query', request?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type UpdateRequestDataStartMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRequestDataStartMutation = { __typename?: 'Mutation', updateRequestDataStart?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type UpdateRequestDataEventMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DataEventInput>;
}>;


export type UpdateRequestDataEventMutation = { __typename?: 'Mutation', updateRequestDataEvent?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type UpdateRequestDataPromoterMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DataPromoterInput>;
}>;


export type UpdateRequestDataPromoterMutation = { __typename?: 'Mutation', updateRequestDataPromoter?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type UpdateRequestDataTechMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DataTechInput>;
}>;


export type UpdateRequestDataTechMutation = { __typename?: 'Mutation', updateRequestDataTech?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type UpdateRequestDataTimesMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DataTimesInput>;
}>;


export type UpdateRequestDataTimesMutation = { __typename?: 'Mutation', updateRequestDataTimes?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type UpdateRequestDataFeeMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DataFeeInput>;
}>;


export type UpdateRequestDataFeeMutation = { __typename?: 'Mutation', updateRequestDataFee?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type UpdateRequestDataAccomodationMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DataAccomodationInput>;
}>;


export type UpdateRequestDataAccomodationMutation = { __typename?: 'Mutation', updateRequestDataAccomodation?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type ConfirmRequestMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<ConfirmationInput>;
}>;


export type ConfirmRequestMutation = { __typename?: 'Mutation', confirmRequest?: { __typename?: 'Request', id: string, confirmed?: boolean | null, confirmed_name?: string | null, confirmed_phone?: string | null, confirmed_email?: string | null, confirmed_at?: string | null, steps_done?: number | null, main_email?: string | null, event_name?: string | null, event_date?: string | null, event_address_place?: string | null, event_address_street?: string | null, event_address_city?: string | null, event_address_zip?: string | null, event_address_gps?: string | null, promoter_name?: string | null, promoter_email?: string | null, promoter_phone?: string | null, contract_ico?: string | null, contract_address_street?: string | null, contract_address_city?: string | null, contract_address_zip?: string | null, contract_name?: string | null, tech_sound_name?: string | null, tech_sound_email?: string | null, tech_sound_phone?: string | null, tech_update_at?: string | null, tech_contact_name?: string | null, tech_contact_email?: string | null, tech_contact_phone?: string | null, time_arrival?: string | null, time_podium_access?: string | null, time_sound_test?: string | null, time_dinner?: string | null, time_hall_opening?: string | null, time_performance?: string | null, time_update_at?: string | null, fee_type?: FeeType | null, fee_amount?: number | null, fee_travel?: number | null, fee_total?: number | null, fee_other?: string | null, fee_payment_type?: PaymentType | null, fee_paying_name?: string | null, fee_paying_email?: string | null, fee_vat?: boolean | null, accomodation?: boolean | null, accomodation_type?: AccomodationType | null, accomodation_name?: string | null, accomodation_street?: string | null, accomodation_city?: string | null, accomodation_zip?: string | null, accomodation_gps?: string | null, accomodation_event_distance?: number | null, accomodation_web?: string | null, accomodation_phone?: string | null, accomodation_check_in?: string | null, accomodation_check_out?: string | null, accomodation_breakfast?: boolean | null, accomodation_internet_access?: boolean | null, accomodation_update_at?: string | null, prefilled?: boolean | null, notified_at?: string | null, isCompleted?: boolean | null, artist?: { __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null, organization?: { __typename?: 'Organization', logo?: string | null } | null } | null };

export type ArtistsQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtistsQuery = { __typename?: 'Query', artists: Array<{ __typename?: 'Artist', id: string, name?: string | null, url?: string | null, vat_invoicing?: boolean | null, rider_link?: string | null } | null> };

export const BaseRequestBookerFragmentFragmentDoc = gql`
    fragment BaseRequestBookerFragment on Request {
  id
  artist {
    id
    name
    url
    vat_invoicing
    rider_link
  }
  confirmed
  confirmed_name
  confirmed_phone
  confirmed_email
  steps_done
  main_email
  event_name
  event_date
  event_address_place
  event_address_street
  event_address_city
  event_address_zip
  event_address_gps
  promoter_name
  promoter_email
  promoter_phone
  contract_ico
  contract_address_street
  contract_address_city
  contract_address_zip
  contract_name
  tech_sound_name
  tech_sound_email
  tech_sound_phone
  tech_contact_name
  tech_contact_email
  tech_contact_phone
  time_arrival
  time_podium_access
  time_sound_test
  time_dinner
  time_hall_opening
  time_performance
  fee_type
  fee_amount
  fee_travel
  fee_total
  fee_other
  fee_vat
  fee_payment_type
  fee_paying_name
  fee_paying_email
  accomodation
  accomodation_type
  accomodation_name
  accomodation_street
  accomodation_city
  accomodation_zip
  accomodation_gps
  accomodation_event_distance
  accomodation_web
  accomodation_phone
  accomodation_check_in
  accomodation_check_out
  accomodation_breakfast
  accomodation_internet_access
  tech_update_at
  time_update_at
  accomodation_update_at
  exported_at
  notified_at
  isCompleted
  link_invoice
  link_contract
  prefilled
}
    `;
export const BaseRequestBookingFragmentFragmentDoc = gql`
    fragment BaseRequestBookingFragment on Request {
  id
  artist {
    id
    name
    url
    vat_invoicing
    rider_link
  }
  organization {
    logo
  }
  confirmed
  confirmed_name
  confirmed_phone
  confirmed_email
  confirmed_at
  steps_done
  main_email
  event_name
  event_date
  event_address_place
  event_address_street
  event_address_city
  event_address_zip
  event_address_gps
  promoter_name
  promoter_email
  promoter_phone
  contract_ico
  contract_address_street
  contract_address_city
  contract_address_zip
  contract_name
  tech_sound_name
  tech_sound_email
  tech_sound_phone
  tech_update_at
  tech_contact_name
  tech_contact_email
  tech_contact_phone
  time_arrival
  time_podium_access
  time_sound_test
  time_dinner
  time_hall_opening
  time_performance
  time_update_at
  fee_type
  fee_amount
  fee_travel
  fee_total
  fee_other
  fee_payment_type
  fee_paying_name
  fee_paying_email
  fee_vat
  accomodation
  accomodation_type
  accomodation_name
  accomodation_street
  accomodation_city
  accomodation_zip
  accomodation_gps
  accomodation_event_distance
  accomodation_web
  accomodation_phone
  accomodation_check_in
  accomodation_check_out
  accomodation_breakfast
  accomodation_internet_access
  accomodation_update_at
  prefilled
  notified_at
  isCompleted
}
    `;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    name
    email
  }
}
    `;

export function useCurrentUserQuery(options?: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentUserQuery, CurrentUserQueryVariables>({ query: CurrentUserDocument, ...options });
};
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    access_token
    refresh_token
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    access_token
    refresh_token
  }
}
    `;

export function useRefreshTokenMutation() {
  return Urql.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument);
};
export const OrganizationDocument = gql`
    query Organization {
  organization {
    name
    logo
    url
    email
  }
}
    `;

export function useOrganizationQuery(options?: Omit<Urql.UseQueryArgs<OrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationQuery, OrganizationQueryVariables>({ query: OrganizationDocument, ...options });
};
export const OrganizationEmailsDocument = gql`
    query OrganizationEmails {
  organizationEmails {
    id
    type
    email
  }
}
    `;

export function useOrganizationEmailsQuery(options?: Omit<Urql.UseQueryArgs<OrganizationEmailsQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationEmailsQuery, OrganizationEmailsQueryVariables>({ query: OrganizationEmailsDocument, ...options });
};
export const RequestCountsDocument = gql`
    query RequestCounts($filter: FilterRequestInput) {
  requestCounts(filter: $filter) {
    confirmed
    completed
    incompleted
    exported
    nonExported
    past
    nonConfirmed
  }
}
    `;

export function useRequestCountsQuery(options?: Omit<Urql.UseQueryArgs<RequestCountsQueryVariables>, 'query'>) {
  return Urql.useQuery<RequestCountsQuery, RequestCountsQueryVariables>({ query: RequestCountsDocument, ...options });
};
export const RequestsDocument = gql`
    query Requests($type: RequestType, $filter: FilterRequestInput) {
  requests(type: $type, filter: $filter) {
    ...BaseRequestBookerFragment
  }
}
    ${BaseRequestBookerFragmentFragmentDoc}`;

export function useRequestsQuery(options?: Omit<Urql.UseQueryArgs<RequestsQueryVariables>, 'query'>) {
  return Urql.useQuery<RequestsQuery, RequestsQueryVariables>({ query: RequestsDocument, ...options });
};
export const BookerRequestDocument = gql`
    query BookerRequest($url: String) {
  request(url: $url) {
    ...BaseRequestBookerFragment
  }
}
    ${BaseRequestBookerFragmentFragmentDoc}`;

export function useBookerRequestQuery(options?: Omit<Urql.UseQueryArgs<BookerRequestQueryVariables>, 'query'>) {
  return Urql.useQuery<BookerRequestQuery, BookerRequestQueryVariables>({ query: BookerRequestDocument, ...options });
};
export const RequestDetailDocument = gql`
    query requestDetail($url: String) {
  requestDetail(url: $url) {
    ...BaseRequestBookerFragment
  }
}
    ${BaseRequestBookerFragmentFragmentDoc}`;

export function useRequestDetailQuery(options?: Omit<Urql.UseQueryArgs<RequestDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<RequestDetailQuery, RequestDetailQueryVariables>({ query: RequestDetailDocument, ...options });
};
export const ArtistDocument = gql`
    query Artist($id: ID) {
  artist(id: $id) {
    id
    name
    url
    organization_id
    vat_invoicing
    rider_link
  }
}
    `;

export function useArtistQuery(options?: Omit<Urql.UseQueryArgs<ArtistQueryVariables>, 'query'>) {
  return Urql.useQuery<ArtistQuery, ArtistQueryVariables>({ query: ArtistDocument, ...options });
};
export const BookerArtistsDocument = gql`
    query BookerArtists {
  bookerArtists {
    id
    name
    url
    organization_id
    vat_invoicing
    rider_link
  }
}
    `;

export function useBookerArtistsQuery(options?: Omit<Urql.UseQueryArgs<BookerArtistsQueryVariables>, 'query'>) {
  return Urql.useQuery<BookerArtistsQuery, BookerArtistsQueryVariables>({ query: BookerArtistsDocument, ...options });
};
export const UpsertArtistDocument = gql`
    mutation UpsertArtist($id: ID, $input: ArtistInput!) {
  upsertArtist(id: $id, input: $input) {
    id
    name
    url
    organization_id
    vat_invoicing
    rider_link
  }
}
    `;

export function useUpsertArtistMutation() {
  return Urql.useMutation<UpsertArtistMutation, UpsertArtistMutationVariables>(UpsertArtistDocument);
};
export const UpsertOrganizationEmailDocument = gql`
    mutation UpsertOrganizationEmail($id: ID, $input: OrganizationEmailInput!) {
  upsertOrganizationEmail(id: $id, input: $input) {
    id
    type
    email
  }
}
    `;

export function useUpsertOrganizationEmailMutation() {
  return Urql.useMutation<UpsertOrganizationEmailMutation, UpsertOrganizationEmailMutationVariables>(UpsertOrganizationEmailDocument);
};
export const DeleteOrganizationEmailDocument = gql`
    mutation DeleteOrganizationEmail($id: ID) {
  deleteOrganizationEmail(id: $id) {
    id
    type
    email
  }
}
    `;

export function useDeleteOrganizationEmailMutation() {
  return Urql.useMutation<DeleteOrganizationEmailMutation, DeleteOrganizationEmailMutationVariables>(DeleteOrganizationEmailDocument);
};
export const UpdateOrganizationPrimaryEmailDocument = gql`
    mutation UpdateOrganizationPrimaryEmail($email: String) {
  updateOrganizationPrimaryEmail(email: $email) {
    name
    logo
    url
    email
  }
}
    `;

export function useUpdateOrganizationPrimaryEmailMutation() {
  return Urql.useMutation<UpdateOrganizationPrimaryEmailMutation, UpdateOrganizationPrimaryEmailMutationVariables>(UpdateOrganizationPrimaryEmailDocument);
};
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: UpdatePassword!) {
  updatePassword(input: $input) {
    status
    message
  }
}
    `;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument);
};
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    status
    message
    currentUser {
      id
      name
      email
    }
  }
}
    `;

export function useUpdateProfileMutation() {
  return Urql.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument);
};
export const UpsertRequestPropertyValueDocument = gql`
    mutation UpsertRequestPropertyValue($id: ID, $name: String, $value: String) {
  upsertRequestPropertyValue(id: $id, name: $name, value: $value) {
    ...BaseRequestBookerFragment
  }
}
    ${BaseRequestBookerFragmentFragmentDoc}`;

export function useUpsertRequestPropertyValueMutation() {
  return Urql.useMutation<UpsertRequestPropertyValueMutation, UpsertRequestPropertyValueMutationVariables>(UpsertRequestPropertyValueDocument);
};
export const UpsertRequestDocument = gql`
    mutation UpsertRequest($id: ID, $input: RequestInput!) {
  upsertRequest(id: $id, input: $input) {
    ...BaseRequestBookerFragment
  }
}
    ${BaseRequestBookerFragmentFragmentDoc}`;

export function useUpsertRequestMutation() {
  return Urql.useMutation<UpsertRequestMutation, UpsertRequestMutationVariables>(UpsertRequestDocument);
};
export const UpdateExportedDocument = gql`
    mutation UpdateExported($id: ID) {
  updateExported(id: $id) {
    ...BaseRequestBookerFragment
  }
}
    ${BaseRequestBookerFragmentFragmentDoc}`;

export function useUpdateExportedMutation() {
  return Urql.useMutation<UpdateExportedMutation, UpdateExportedMutationVariables>(UpdateExportedDocument);
};
export const UrgentRequestDocument = gql`
    mutation UrgentRequest($id: ID) {
  urgentRequest(id: $id) {
    ...BaseRequestBookerFragment
  }
}
    ${BaseRequestBookerFragmentFragmentDoc}`;

export function useUrgentRequestMutation() {
  return Urql.useMutation<UrgentRequestMutation, UrgentRequestMutationVariables>(UrgentRequestDocument);
};
export const BookerDocument = gql`
    query Booker($url: String) {
  booker(url: $url) {
    url
    logo
  }
}
    `;

export function useBookerQuery(options?: Omit<Urql.UseQueryArgs<BookerQueryVariables>, 'query'>) {
  return Urql.useQuery<BookerQuery, BookerQueryVariables>({ query: BookerDocument, ...options });
};
export const BookerByRequestUrlDocument = gql`
    query BookerByRequestUrl($url: String) {
  bookerByRequestUrl(url: $url) {
    url
    logo
  }
}
    `;

export function useBookerByRequestUrlQuery(options?: Omit<Urql.UseQueryArgs<BookerByRequestUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<BookerByRequestUrlQuery, BookerByRequestUrlQueryVariables>({ query: BookerByRequestUrlDocument, ...options });
};
export const BookingRequestDocument = gql`
    query BookingRequest($url: String) {
  request(url: $url) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useBookingRequestQuery(options?: Omit<Urql.UseQueryArgs<BookingRequestQueryVariables>, 'query'>) {
  return Urql.useQuery<BookingRequestQuery, BookingRequestQueryVariables>({ query: BookingRequestDocument, ...options });
};
export const RequestStateDocument = gql`
    query RequestState($url: String) {
  requestState(url: $url) {
    id
    finished
  }
}
    `;

export function useRequestStateQuery(options?: Omit<Urql.UseQueryArgs<RequestStateQueryVariables>, 'query'>) {
  return Urql.useQuery<RequestStateQuery, RequestStateQueryVariables>({ query: RequestStateDocument, ...options });
};
export const RequestDocument = gql`
    query Request($url: String) {
  request(url: $url) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useRequestQuery(options?: Omit<Urql.UseQueryArgs<RequestQueryVariables>, 'query'>) {
  return Urql.useQuery<RequestQuery, RequestQueryVariables>({ query: RequestDocument, ...options });
};
export const UpdateRequestDataStartDocument = gql`
    mutation UpdateRequestDataStart($url: String) {
  updateRequestDataStart(url: $url) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useUpdateRequestDataStartMutation() {
  return Urql.useMutation<UpdateRequestDataStartMutation, UpdateRequestDataStartMutationVariables>(UpdateRequestDataStartDocument);
};
export const UpdateRequestDataEventDocument = gql`
    mutation UpdateRequestDataEvent($url: String, $input: DataEventInput) {
  updateRequestDataEvent(url: $url, input: $input) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useUpdateRequestDataEventMutation() {
  return Urql.useMutation<UpdateRequestDataEventMutation, UpdateRequestDataEventMutationVariables>(UpdateRequestDataEventDocument);
};
export const UpdateRequestDataPromoterDocument = gql`
    mutation UpdateRequestDataPromoter($url: String, $input: DataPromoterInput) {
  updateRequestDataPromoter(url: $url, input: $input) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useUpdateRequestDataPromoterMutation() {
  return Urql.useMutation<UpdateRequestDataPromoterMutation, UpdateRequestDataPromoterMutationVariables>(UpdateRequestDataPromoterDocument);
};
export const UpdateRequestDataTechDocument = gql`
    mutation UpdateRequestDataTech($url: String, $input: DataTechInput) {
  updateRequestDataTech(url: $url, input: $input) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useUpdateRequestDataTechMutation() {
  return Urql.useMutation<UpdateRequestDataTechMutation, UpdateRequestDataTechMutationVariables>(UpdateRequestDataTechDocument);
};
export const UpdateRequestDataTimesDocument = gql`
    mutation UpdateRequestDataTimes($url: String, $input: DataTimesInput) {
  updateRequestDataTimes(url: $url, input: $input) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useUpdateRequestDataTimesMutation() {
  return Urql.useMutation<UpdateRequestDataTimesMutation, UpdateRequestDataTimesMutationVariables>(UpdateRequestDataTimesDocument);
};
export const UpdateRequestDataFeeDocument = gql`
    mutation UpdateRequestDataFee($url: String, $input: DataFeeInput) {
  updateRequestDataFee(url: $url, input: $input) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useUpdateRequestDataFeeMutation() {
  return Urql.useMutation<UpdateRequestDataFeeMutation, UpdateRequestDataFeeMutationVariables>(UpdateRequestDataFeeDocument);
};
export const UpdateRequestDataAccomodationDocument = gql`
    mutation UpdateRequestDataAccomodation($url: String, $input: DataAccomodationInput) {
  updateRequestDataAccomodation(url: $url, input: $input) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useUpdateRequestDataAccomodationMutation() {
  return Urql.useMutation<UpdateRequestDataAccomodationMutation, UpdateRequestDataAccomodationMutationVariables>(UpdateRequestDataAccomodationDocument);
};
export const ConfirmRequestDocument = gql`
    mutation ConfirmRequest($url: String, $input: ConfirmationInput) {
  confirmRequest(url: $url, input: $input) {
    ...BaseRequestBookingFragment
  }
}
    ${BaseRequestBookingFragmentFragmentDoc}`;

export function useConfirmRequestMutation() {
  return Urql.useMutation<ConfirmRequestMutation, ConfirmRequestMutationVariables>(ConfirmRequestDocument);
};
export const ArtistsDocument = gql`
    query Artists($url: String) {
  artists(url: $url) {
    id
    name
    url
    vat_invoicing
    rider_link
  }
}
    `;

export function useArtistsQuery(options?: Omit<Urql.UseQueryArgs<ArtistsQueryVariables>, 'query'>) {
  return Urql.useQuery<ArtistsQuery, ArtistsQueryVariables>({ query: ArtistsDocument, ...options });
};